/**
 * The sync engine reports `auth_error` (HTTP 401) for a scope — the title bar
 * turns orange with "Needs re-authentication". Nothing reacted to it: the
 * engine retried with the same token until the next SCHEDULED refresh, up to
 * ~14 min later (owner report 05.10.2026: "the orange cloud stays after the
 * backend is back"). Now an `auth_error` refreshes the token at once —
 * rate-limited, single-flight through `refreshNow` — and the new token goes
 * to the engine (`persistTokens` → `sync_set_auth`), whose interruptible wait
 * retries immediately.
 */
import { refreshNow, hasRefreshableSession } from './tokenRefresher';

/** At most one recovery attempt per this many ms, however many scopes 401. */
export const AUTH_RECOVERY_MIN_INTERVAL_MS = 60_000;

let lastAttempt = 0;

/** For tests. */
export function resetSyncAuthRecovery() {
  lastAttempt = 0;
}

/**
 * Called with every engine status payload. Returns true when it started a
 * refresh. Never throws: a failed refresh is the refresher's own business
 * (the 401 handler decides about the session).
 */
export function onSyncStatus(payload, now = Date.now()) {
  if (payload?.status !== 'auth_error') return false;
  if (!hasRefreshableSession()) return false;
  if (now - lastAttempt < AUTH_RECOVERY_MIN_INTERVAL_MS) return false;
  lastAttempt = now;
  refreshNow().catch(() => {});
  return true;
}
